















































import { Component, Vue } from 'vue-property-decorator'
import { mapGetters } from 'vuex'

import BaseImage from '@/components/common/BaseImage.vue'
import BaseLink from '@/components/common/BaseLink.vue'
import BaseLogin from '@/components/common/BaseLogin.vue'

@Component( {
    components: {
        'oe-base-image': BaseImage,
        'oe-link': BaseLink,
        'oe-base-login': BaseLogin
    },
    computed: mapGetters( {
        currentUser: 'usersModule/currentUser'
    } )
} )
export default class CreateAssociationOverlay extends Vue {
    associationCreated = false
    createAssociationActive = false
    createdAssociation = {
        contentRaw: '',
        infoOnUpdate: false
    }
    emptyAssociation = false
    currentUser!: any

    get localAssociationsLength() {
        const localAssociations = localStorage.getItem( 'localAssociations' )

        return localAssociations ? JSON.parse( localAssociations ).length : 0
    }

    showOverlay() {
        this.createAssociationActive = true
        this.$store.commit( 'globalModule/setBodyFixed' )
    }

    closeOverlay( event: Event ) {
        event.preventDefault()

        this.createAssociationActive = false
        this.associationCreated = false
        this.resetAssociation()
        this.$store.commit( 'globalModule/setBodyFixed' )
    }

    createAssociation() {
        let associationActionType = 'associationsModule/createLocalAssociation'
        if ( this.createdAssociation.contentRaw === '' ) {
            this.emptyAssociation = true
        } else {
            if ( this.currentUser.isRegistered ) {
                associationActionType = 'associationsModule/createAssociation'
            }

            this.$store.dispatch( associationActionType, this.createdAssociation )
                .then( () => {
                    this.associationCreated = true
                    this.resetAssociation()
                } )
        }
    }

    discardAssociation() {
        this.associationCreated = false
    }

    resetAssociation() {
        this.emptyAssociation = false
        this.createdAssociation = {
            contentRaw: '',
            infoOnUpdate: false
        }
    }
}
 